export default __webpack_public_path__ + "static/media/pdfIcon.4ecc8879.png";